module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Broom-08807c09f1b12d284fceab7d88ecbe61.svg";